import React from 'react';
import {
  DisponibilidadeCard,
  DispTitle,
  DispInfo,
  DispSub,
} from '../../style/ModalDesignacao.styles';

const DisponibilidadeItem = ({ disponibilidade }) => (
  <DisponibilidadeCard>
    <DispTitle>Disponibilidade</DispTitle>
    <DispInfo>
      {disponibilidade.dia}, {disponibilidade.horario.join(' / ')}
    </DispInfo>
    <DispSub>{disponibilidade.frequencia}</DispSub>
  </DisponibilidadeCard>
);

export default DisponibilidadeItem;
